import React, { useState } from 'react';
import Tooltip from '../../../ViewWrapperContainer/ViewWrapper/ToolTip/ToolTip';
import './PanoControlButtonV2.scss';

const PanoControlButtonV2 = ({
    icon,
    onClick,
    active,
    primaryColor = '#009b65',
    title,
}) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const backgroundColor = active ? primaryColor : 'white';
  const color = active ? 'white' : primaryColor;

  return (
    <button
      className="pano-ctrl-btn-v2"
      aria-label={`Toggle ${title}`}
      aria-pressed={active}
      onClick={onClick}
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
      onFocus={() => setShowTooltip(true)}
      onBlur={() => setShowTooltip(false)}
      style={{ backgroundColor }}
    >
      <i aria-hidden="true" className="material-icons" style={{ color }}>{icon}</i>
      <Tooltip
          tooltipClass={'pano-control-button-tooltip'}
          text={title}
          show={showTooltip}
          position={'left'}
          style={{
              backgroundColor: primaryColor,
              color: 'white',
          }}
          node=".pano-ctrl-btn-v2"
      />
    </button>
  );
};

export default PanoControlButtonV2;
